"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.symbol = symbol;
function symbol() {
    // eslint-disable-next-line max-len,quotes
    return '<symbol viewbox="0 0 18 18" id=icon-radio-checked-18><path fill-rule=evenodd clip-rule=evenodd d="M9 0a9 9 0 1 0 0 18A9 9 0 0 0 9 0Zm0 17A8 8 0 1 1 9 1a8 8 0 0 1 0 16Zm5-8A5 5 0 1 1 4 9a5 5 0 0 1 10 0Z"></path></symbol>';
}
